import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import StarsCollectedStyled, { Text } from './StarsCollected.styled';

const mapStateToProps = state => ({
  stars:
    state.saved.best
      .map(item => item.starCount)
      .reduce((acc, curr) => acc + curr) || 0,
  total: state.gameData.length * 3,
});

export const StarsCollected = ({ stars, total }) => (
  <StarsCollectedStyled>
    <Text>
      Collected <span>{stars}</span> of <span>{total}</span> stars
    </Text>
  </StarsCollectedStyled>
);

export default connect(mapStateToProps)(StarsCollected);

StarsCollected.propTypes = {
  stars: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/atoms/StarsCollected/StarsCollected.js